// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandWordmark_root__lnaCD"};